import React from 'react';
import { FacebookShareButton, TwitterShareButton } from 'react-share';
import styled from 'styled-components';

import FacebookIcon from './../utility/FacebookIcon';
import TwitterIcon from './../utility/TwitterIcon';

const ShareButtons = ({ permalink }) => {
  return (
    <ShareButtonContainer>
      <Title>सोसल मिडियामा सेयर</Title>
      <FacebookShareButton url={`https://nayayougbodh.com${permalink}`}>
        <ShareButton color="#3C5A99" style={{ marginRight: '1rem' }}>
          <FacebookIcon size="1x" />
        </ShareButton>
      </FacebookShareButton>

      <TwitterShareButton url={`https://nayayougbodh.com${permalink}`}>
        <ShareButton color="#1DA1F2">
          <TwitterIcon size="1x" />
        </ShareButton>
      </TwitterShareButton>
    </ShareButtonContainer>
  );
};

const ShareButtonContainer = styled.div`
  margin: 1rem 0;
  display: inline-flex;
  align-items: stretch;
  background-color: #f0f0f0;
  padding: 1rem 2rem;
`;

const Title = styled.h4`
  padding-right: 1rem;
`;

const ShareButton = styled.button`
  border: none;
  box-shadow: none;
  background-color: ${({ color }) => color};
  color: #f0f0f0;
  padding: 0.5rem 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
`;

export default ShareButtons;
